import { getAccountBadgeFiltersEssential } from './getAccountBadgeFiltersEssential';
export function getAccountBadgeFiltersByStatus(badgeId, status, op = '=') {
    return [
        ...getAccountBadgeFiltersEssential(),
        {
            op: '=',
            column: 'badgeId',
            value: badgeId,
        },
        {
            op,
            column: 'status',
            value: status,
        },
    ];
}
